import script from "./port-list-top10.vue?vue&type=script&setup=true&lang=ts"
export * from "./port-list-top10.vue?vue&type=script&setup=true&lang=ts"

import "./port-list-top10.vue?vue&type=style&index=0&id=745d2d35&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-745d2d35"]])

export default __exports__